import React from 'react';

import './styles.css';

export default props => {
  return (
    <div className="Story" style={props.style}>
      <div className="Story__inner">
        <div className="Story__title">
          Скорость при 5G: <br />
          до 20 Гбит/с
        </div>
        <div className="Story__speedometer" />
        <div className="Story__bottom">
          <b>2,46 Гбит/c:</b><br /> скорость, которую уже в сентябре 2019 года МегаФон показал в тестовой зоне 5g
        </div>
      </div>
    </div>
  );
};

/*
				<div className="Story__speed">
					100 ТБ/С
				</div>
*/
